import { getAjax, postAjax } from './index.js';

/**
 * 获取下载中心列表
 * @param {*} params
 * @returns
 */
export const getDownloadCenterList = async params => {
  const { data = {} } = await getAjax('downloadCenter/list', params);
  return data;
};

/**
 * 下载中心 批量删除
 * @param {*} params
 * @returns
 */
export const deleteBatchDownloadCenter = async params => {
  const res = await postAjax('downloadCenter/deleteBatch', params);
  return res;
};

/**
 * 下载中心 删除
 * @param {*} params
 * @returns
 */
export const deleteDownloadCenter = async params => {
  const res = await postAjax('downloadCenter/delete', params);
  return res;
};

/**
 * 导出身份校验
 * @param {*} params
 * @returns
 */
export const isVerifyDownloadCenter = async params => {
  const { data = {} } = await postAjax('downloadCenter/isVerify', params);
  return data;
};

/**
 * 下载单个
 * @param {*} params
 * @returns
 */
export const downloadFileDownloadCenter = async params => {
  const { data = {} } = await postAjax('downloadCenter/downloadFile', params);
  return data;
};
/**
 * 下载单个 短信校验
 * @param {*} params
 * @returns
 */
 export const downloadFileByVerifyDownloadCenter = async params => {
  const res = await postAjax('downloadCenter/downloadFileByVerify', params);
  return res;
};


/**
 * 下载单个
 * @param {*} params
 * @returns
 */
export const sendVerifyCodeDownloadCenter = async params => {
  const { data = {} } = await postAjax('downloadCenter/sendVerifyCode', params);
  return data;
};
